import React, { Children, createContext, useMemo } from "react";
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { buildSarasDnDId, useSarasDnDDragState } from './SarasDnDProvider';

export const SarasDnDListContext = createContext({ groupKey: null });

const SarasDnDList = ({ groupKey, sarasDnDManager, children, wrapperStyle }) => {
    const laneGroupKey = String(groupKey);
    const childArray = Children.toArray(children);
    const items = childArray
        .map((child) => child?.props?.rowKey)
        .filter((rowKey) => rowKey !== undefined && rowKey !== null)
        .map((rowKey) => buildSarasDnDId(groupKey, rowKey));
    const { activeGroupKey, activeId, destinationGroupKey, destinationIndex, overId } = useSarasDnDDragState();

    const { isOver, setNodeRef } = useDroppable({
        id: laneGroupKey,
        data: {
            dndType: sarasDnDManager.dndType,
            groupKey: laneGroupKey,
            itemCount: items.length,
        },
    });

    const style = {
        minHeight: '100px',
        height: "100%",
        minWidth: '143px',
        ...wrapperStyle
    };

    const contextValue = useMemo(() => ({
        dndType: sarasDnDManager.dndType,
        groupKey: laneGroupKey,
    }), [laneGroupKey, sarasDnDManager.dndType]);

    const isActiveLane = destinationGroupKey === laneGroupKey || overId === laneGroupKey || isOver;
    const showTailMarker = activeId
        && destinationGroupKey === laneGroupKey
        && items.length > 0
        && destinationIndex === items.length
        && !items.includes(overId);

    // console.log('dndkit list state', {
    //     laneGroupKey,
    //     items,
    //     activeGroupKey,
    //     activeId,
    //     destinationGroupKey,
    //     destinationIndex,
    //     overId,
    //     isOver,
    //     isActiveLane,
    //     showTailMarker
    // });

    return (
        <SarasDnDListContext.Provider value={contextValue}>
            <SortableContext id={laneGroupKey} items={items} strategy={verticalListSortingStrategy}>
                <ul
                    className={"uiDnDDropTarget " + (isActiveLane ? "uiDnDDragOverList" : "")}
                    ref={setNodeRef}
                    style={{
                        ...style,
                        position: 'relative',
                    }}
                >
                    {children}
                    {showTailMarker ? (
                        <li
                            aria-hidden="true"
                            style={{
                                listStyle: 'none',
                                height: '14px',
                                margin: '0 0 12px 0',
                                position: 'relative',
                            }}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '6px',
                                    left: '8px',
                                    right: '8px',
                                    height: '3px',
                                    borderRadius: '999px',
                                    background: '#1f6feb',
                                    boxShadow: '0 0 0 3px rgba(31, 111, 235, 0.14)',
                                }}
                            />
                        </li>
                    ) : null}
                </ul>
            </SortableContext>
        </SarasDnDListContext.Provider>
    )
};

export default SarasDnDList;
